
import {Component, Prop, Vue, Watch, Ref} from "vue-property-decorator";
import {sancionStore} from "@/store/sancionStore";
import {http} from "@/config/HttpClient";
import {DateTime} from "luxon";
import {MaterialService} from "@/services/MaterialService";
import {Alert} from "@/addons/Alert";
import InputUnsignedDecimal from "../../components/InputUnsignedDecimal.vue";
import InputUppercaseRequired from "../../components/InputUppercaseRequired.vue";
import InputUppercase from "../../components/InputUppercase.vue";
import {materialStore} from "@/store/materialStore";
import {IngresoService} from "@/services/IngresoService";
import {ingresoStore} from "@/store/ingresoStore";
import * as stream from "stream";
import router from "@/router";

@Component({
  name: "materialNew",
  components: {InputUnsignedDecimal, InputUppercaseRequired, InputUppercase},
})
export default class extends Vue {
  @Ref('fileInput') fileInput!: HTMLInputElement;

  sancion = {
    codigo: '',
    meses_plazo: 1,

  }

  @Prop() isNew!: boolean
  @Prop() materialEdit!: any
  private iniciado = 'Iniciado'
  private materialStore = materialStore();
  private sancionStore = sancionStore();
  private ingresoStore = ingresoStore();
  private materialService = MaterialService.getInstance();
  private ingresolService = IngresoService.getInstance();
  private fecha = DateTime.now().toFormat("yyyy-MM-dd");
  private headers = [
    {text: "Fecha", value: "fecha"},
    {text: "Acción", value: "accion"},
    {text: "Usuario", value: "user.email"}
  ];

  //search = null;
  validBuscar = false;
  valid = false;
  txtBuscar = '';
  cantidad= 1;
  cantidad_entregada= 1;
  precio_unitario= 1;
  isEdit = false;
  txtNroTramite = '';
  isLoading = false;
  swEditar = true;
  txtSearch = "";
  private imageBase64: string | null = null;

  material = {
    id: this.$route.params.materialEdit.id,
    codigo: this.$route.params.materialEdit.codigo,
    descripcion: this.$route.params.materialEdit.descripcion,
    partida: this.$route.params.materialEdit.partida,
    unidad: this.$route.params.materialEdit.unidad,
    fecha_creacion: this.$route.params.materialEdit.fecha_creacion,
    numero: this.$route.params.materialEdit.numero,
    partida_id: this.$route.params.materialEdit.partida_gasto_id,
    grupo_id: this.$route.params.materialEdit.grupo_material_id,
    imagen: this.$route.params.materialEdit.imagen
  };
  clientes = [];
  materiales = [];
  cliente_seleccionado = null;
  private cuenta = null;

  //private sancion = [];

  //private sancion = null;

  $refs!: {
    form: HTMLFormElement,
    txtCuenta: HTMLInputElement,
    montoRec: HTMLInputElement,
  };

  mounted() {
    this.getGrupoMaterial();
    this.getPartidaGasto();
  }

  get nuevoMaterial(): any[] {
    return this.materialStore.newMaterial;
  }

  get loading(): boolean {
    return this.materialStore.loading;
  }


  get grupoMaterial(): any {
    return this.materialStore.grupoMaterial;
  }

  getGrupoMaterial() {
    this.materialService.getGrupoMaterial();
  }

  get partidaGasto(): any {
    return this.materialStore.partidaGasto;
  }

  getPartidaGasto() {
    this.materialService.getPartidaGasto();
  }

  guardar(){
    if (!this.$refs.form.validate()) {
      return;
    }
    Alert.confirm(`Actualizar el Material: <br>
                    ${this.material.descripcion}`
    ).then(res => {
      const data = {materialId:this.material.id, material:this.material}
      if (res.isConfirmed) {
        this.materialService.updateMaterial(data);
        //router.push({name: 'materiales'});
        //this.$emit('listar')
      }
    })
  }

  private handleFileChange(): void {
    const files = this.fileInput.files;
    if (files && files.length > 0) {
      const reader = new FileReader();
      reader.onload = () => {
        this.imageBase64 = reader.result as string;
      };
      reader.readAsDataURL(files[0]);
    }
  }


  private uploadImage(): void {
    if (!this.imageBase64) {
      alert('Por favor selecciona una imagen.');
      return;
    }

    const data = {image: this.imageBase64, id: this.material.id}

    this.materialService.adjuntarImagen(data);
  }



}
